// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AthenaScreen-module__font-s-10___vslrQ {
  font-size: 10px !important;
}

.AthenaScreen-module__font-s-12___m5nHw {
  font-size: 12px !important;
}

.AthenaScreen-module__font-s-13___pehF7 {
  font-size: 13px !important;
}

.AthenaScreen-module__font-s-14___skGhI {
  font-size: 14px !important;
}

.AthenaScreen-module__font-s-15___CCLCl {
  font-size: 15px !important;
}

.AthenaScreen-module__font-s-16___MMiDQ {
  font-size: 16px !important;
}

.AthenaScreen-module__font-s-18___YRx94 {
  font-size: 18px !important;
}

.AthenaScreen-module__font-s-20____pbEE {
  font-size: 20px !important;
}

.AthenaScreen-module__font-s-22___LIOan {
  font-size: 22px !important;
}

.AthenaScreen-module__font-s-28___A74wA {
  font-size: 28px !important;
}

.AthenaScreen-module__font-w-400___DFwDG {
  font-weight: 400 !important;
}

.AthenaScreen-module__font-w-500___gnLwc {
  font-weight: 500 !important;
}

.AthenaScreen-module__font-w-600___Ji1Dn {
  font-weight: 600 !important;
}

.AthenaScreen-module__font-w-700___ZK614 {
  font-weight: 700 !important;
}

.AthenaScreen-module__p-5___bpMGE {
  padding: 5px !important;
}

.AthenaScreen-module__p-12___YM8lP {
  padding: 12px !important;
}

.AthenaScreen-module__p-16___xf12T {
  padding: 16px !important;
}

.AthenaScreen-module__p-30___XNxu_ {
  padding: 30px !important;
}

.AthenaScreen-module__p-b-0___pHzDl {
  padding-bottom: 0 !important;
}

.AthenaScreen-module__p-b-5___VwoRn {
  padding-bottom: 5px !important;
}

.AthenaScreen-module__p-b-10___ajKk7 {
  padding-bottom: 10px !important;
}

.AthenaScreen-module__p-b-12___Ypm4E {
  padding-bottom: 12px !important;
}

.AthenaScreen-module__p-b-16___r498R {
  padding-bottom: 16px !important;
}

.AthenaScreen-module__p-b-18___GGz76 {
  padding-bottom: 18px !important;
}

.AthenaScreen-module__p-b-20___OgMNd {
  padding-bottom: 20px !important;
}

.AthenaScreen-module__p-b-25___M_tI3 {
  padding-bottom: 25px !important;
}

.AthenaScreen-module__p-b-30___EUGPs {
  padding-bottom: 30px !important;
}

.AthenaScreen-module__p-b-50___iKc1F {
  padding-bottom: 50px !important;
}

.AthenaScreen-module__p-t-0___lSab5 {
  padding-top: 0 !important;
}

.AthenaScreen-module__p-t-12___L45TT {
  padding-top: 12px !important;
}

.AthenaScreen-module__p-t-16___dhXSs {
  padding-top: 16px !important;
}

.AthenaScreen-module__p-t-18___z8Q35 {
  padding-top: 18px !important;
}

.AthenaScreen-module__p-t-20___kZHzt {
  padding-top: 20px !important;
}

.AthenaScreen-module__p-t-30___ntUIz {
  padding-top: 30px !important;
}

.AthenaScreen-module__p-t-40___pJiBI {
  padding-top: 40px !important;
}

.AthenaScreen-module__p-t-50___a0LTu {
  padding-top: 50px !important;
}

.AthenaScreen-module__p-l-20___JLUqD {
  padding-left: 20px !important;
}

.AthenaScreen-module__p-l-30___Qz7JA {
  padding-left: 30px !important;
}

.AthenaScreen-module__p-l-40___uXbae {
  padding-left: 40px !important;
}

.AthenaScreen-module__p-r-16___qgUgC {
  padding-right: 16px !important;
}

.AthenaScreen-module__p-r-20___Sxacm {
  padding-right: 20px !important;
}

.AthenaScreen-module__p-r-30___X4Anl {
  padding-right: 30px !important;
}

.AthenaScreen-module__p-r-50___dJNVl {
  padding-right: 50px !important;
}

.AthenaScreen-module__p-r-60___Aiuk0 {
  padding-right: 60px !important;
}

.AthenaScreen-module__m-b-1___Z1Cei {
  margin-bottom: 1px !important;
}

.AthenaScreen-module__m-b-2___HblZ4 {
  margin-bottom: 2px !important;
}

.AthenaScreen-module__m-b-6___VBwTg {
  margin-bottom: 6px !important;
}

.AthenaScreen-module__m-b-8___L2kWu {
  margin-bottom: 8px !important;
}

.AthenaScreen-module__m-b-10___kJqdZ {
  margin-bottom: 10px !important;
}

.AthenaScreen-module__m-b-14___XqHDM {
  margin-bottom: 14px !important;
}

.AthenaScreen-module__m-b-16___d4V7_ {
  margin-bottom: 16px !important;
}

.AthenaScreen-module__m-b-20___k8M7v {
  margin-bottom: 20px !important;
}

.AthenaScreen-module__m-b-22___HzUcV {
  margin-bottom: 22px !important;
}

.AthenaScreen-module__m-b-24___llrVN {
  margin-bottom: 24px !important;
}

.AthenaScreen-module__m-b-30___fpiCi {
  margin-bottom: 30px !important;
}

.AthenaScreen-module__m-b-32___d1CCG {
  margin-bottom: 32px !important;
}

.AthenaScreen-module__m-b-40___e_vuo {
  margin-bottom: 40px !important;
}

.AthenaScreen-module__m-t-2___Hzly1 {
  margin-top: 2px !important;
}

.AthenaScreen-module__m-t-3___swAKL {
  margin-top: 3px !important;
}

.AthenaScreen-module__m-t-4___wZEQg {
  margin-top: 4px !important;
}

.AthenaScreen-module__m-t-5___H178M {
  margin-top: 5px !important;
}

.AthenaScreen-module__m-t-8___n6QZB {
  margin-top: 8px !important;
}

.AthenaScreen-module__m-t-10___KCD3Z {
  margin-top: 10px !important;
}

.AthenaScreen-module__m-t-15___ONXQE {
  margin-top: 15px !important;
}

.AthenaScreen-module__m-t-16___GxBtq {
  margin-top: 16px !important;
}

.AthenaScreen-module__m-t-20___bG5gK {
  margin-top: 20px !important;
}

.AthenaScreen-module__m-t-22____6Tuq {
  margin-top: 22px !important;
}

.AthenaScreen-module__m-t-30___c9sB6 {
  margin-top: 30px !important;
}

.AthenaScreen-module__m-t-32___yGYzq {
  margin-top: 32px !important;
}

.AthenaScreen-module__m-l-auto___rwP_H {
  margin-left: auto !important;
}

.AthenaScreen-module__m-l-4____ZDeh {
  margin-left: 4px !important;
}

.AthenaScreen-module__m-l-5___sdkfL {
  margin-left: 5px !important;
}

.AthenaScreen-module__m-l-6___B0W5T {
  margin-left: 6px !important;
}

.AthenaScreen-module__m-l-8___YCq97 {
  margin-left: 8px !important;
}

.AthenaScreen-module__m-l-10___jMVCR {
  margin-left: 10px !important;
}

.AthenaScreen-module__m-l-16___rIl2h {
  margin-left: 16px !important;
}

.AthenaScreen-module__m-l-20___LwYam {
  margin-left: 20px !important;
}

.AthenaScreen-module__m-l-24___AKOYG {
  margin-left: 24px !important;
}

.AthenaScreen-module__m-l-30___zVVRg {
  margin-left: 30px !important;
}

.AthenaScreen-module__m-l-35___NnKGW {
  margin-left: 35px !important;
}

.AthenaScreen-module__m-l-40___y68Ew {
  margin-left: 40px !important;
}

.AthenaScreen-module__m-r-8___fFgn5 {
  margin-right: 8px !important;
}

.AthenaScreen-module__m-r-10___x7iSn {
  margin-right: 10px !important;
}

.AthenaScreen-module__m-r-16___sxL5f {
  margin-right: 16px !important;
}

.AthenaScreen-module__m-r-20___DvvPt {
  margin-right: 20px !important;
}

.AthenaScreen-module__m-r-24___xEVhp {
  margin-right: 24px !important;
}

.AthenaScreen-module__m-r-30___KIrAz {
  margin-right: 30px !important;
}

.AthenaScreen-module__m-r-40___VkkQt {
  margin-right: 40px !important;
}

.AthenaScreen-module__border-r-3___dJE1O {
  border-radius: 3px !important;
}

.AthenaScreen-module__border-r-4___mq59y {
  border-radius: 4px !important;
}

.AthenaScreen-module__border-r-6___p0oQp {
  border-radius: 6px !important;
}

.AthenaScreen-module__border-r-10___W4K8U {
  border-radius: 10px !important;
}

.AthenaScreen-module__border-r-12___dPP_h {
  border-radius: 12px !important;
}

.AthenaScreen-module__border-r-16___w_yRX {
  border-radius: 16px !important;
}

.AthenaScreen-module__border-r-50___ezJTL {
  border-radius: 50% !important;
}

.AthenaScreen-module__primary-border___q__ah {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.AthenaScreen-module__primary-border-b___VIlkw {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.AthenaScreen-module__primary-border-t___rrJyT {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.AthenaScreen-module__primary-border-l___s11nc {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.AthenaScreen-module__primary-border-r___a3fEF {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.AthenaScreen-module__secondary-border____nNUn {
  border: 1px solid #637768;
}

.AthenaScreen-module__secondary-border-b___QAfTG {
  border-bottom: 1px solid #637768;
}

.AthenaScreen-module__secondary-border-t___XbOJA {
  border-top: 1px solid #637768;
}

.AthenaScreen-module__secondary-border-l___hRpJp {
  border-left: 1px solid #637768;
}

.AthenaScreen-module__secondary-border-r___S8lfo {
  border-right: 1px solid #637768;
}

.AthenaScreen-module__gap-0___a4GUK {
  gap: 0 !important;
}

.AthenaScreen-module__gap-2___saLHw {
  gap: 2px !important;
}

.AthenaScreen-module__gap-4___Rp4CW {
  gap: 4px !important;
}

.AthenaScreen-module__gap-5___jKXdD {
  gap: 5px !important;
}

.AthenaScreen-module__gap-6___VHULN {
  gap: 6px !important;
}

.AthenaScreen-module__gap-8____D8v5 {
  gap: 8px !important;
}

.AthenaScreen-module__gap-10___SUk31 {
  gap: 10px !important;
}

.AthenaScreen-module__gap-12___j82J3 {
  gap: 12px !important;
}

.AthenaScreen-module__gap-14___NIwzH {
  gap: 14px !important;
}

.AthenaScreen-module__gap-16___J8P8K {
  gap: 16px !important;
}

.AthenaScreen-module__gap-18___G27c3 {
  gap: 18px !important;
}

.AthenaScreen-module__gap-20___qc9vP {
  gap: 20px !important;
}

.AthenaScreen-module__gap-24___UfM5O {
  gap: 24px !important;
}

.AthenaScreen-module__gap-26___Jhg5U {
  gap: 26px !important;
}

.AthenaScreen-module__gap-30___OitN6 {
  gap: 30px !important;
}

.AthenaScreen-module__gap-32___eX6TQ {
  gap: 32px !important;
}

.AthenaScreen-module__gap-40___Gb3u0 {
  gap: 40px !important;
}

.AthenaScreen-module__gap-50___dnck1 {
  gap: 50px !important;
}

.AthenaScreen-module__flex-1___hlkaX {
  flex: 1;
}

.AthenaScreen-module__flex-none___oFIkl {
  flex: none !important;
}

.AthenaScreen-module__flex-column___mn7mZ {
  display: flex;
  flex-direction: column !important;
}

.AthenaScreen-module__flex-row___G7AU_ {
  display: flex;
  flex-direction: row !important;
}

.AthenaScreen-module__vertically-centered___E1CYP {
  display: flex;
  align-items: center !important;
}

.AthenaScreen-module__horizontally-centered___DVi3W {
  display: flex;
  justify-content: center !important;
}

.AthenaScreen-module__horizontally-end___CYw1V {
  display: flex;
  justify-content: end !important;
}

.AthenaScreen-module__vertically-start___pvy8Q {
  display: flex;
  align-items: start !important;
}

.AthenaScreen-module__space-between___lVCa7 {
  display: flex;
  justify-content: space-between !important;
}

.AthenaScreen-module__flex-wrap___guX2W {
  flex-wrap: wrap !important;
}

.AthenaScreen-module__height-100___btven {
  height: 100%;
}

.AthenaScreen-module__width-50___mMzzu {
  width: 50% !important;
}

.AthenaScreen-module__width-100___YnZWU {
  width: 100%;
}

.AthenaScreen-module__cursor-pointer___ZYbhN {
  cursor: pointer;
}

.AthenaScreen-module__cursor-not-allowed___ITLlr {
  cursor: not-allowed !important;
}

.AthenaScreen-module__absolute-centered___ZKOCB {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.AthenaScreen-module__absolute___B0Hky {
  position: absolute;
}

.AthenaScreen-module__relative___zYls_ {
  position: relative;
}

.AthenaScreen-module__fixed___b8oLf {
  position: fixed;
}

.AthenaScreen-module__visible___YM0JA {
  opacity: 1;
}

.AthenaScreen-module__invisible___X9AC0 {
  opacity: 0;
}

.AthenaScreen-module__col-90___HuTIm {
  width: 90% !important;
}

.AthenaScreen-module__col-auto___BgQUX {
  width: auto !important;
}

.AthenaScreen-module__medical-tabs___mEAHq {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.AthenaScreen-module__medical-table-new___Nv4t5 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.AthenaScreen-module__medical-table-new___Nv4t5:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.AthenaScreen-module__medical-table-new___Nv4t5::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.AthenaScreen-module__medical-table-new___Nv4t5::-webkit-scrollbar-track {
  display: none;
}
.AthenaScreen-module__medical-table-new___Nv4t5.AthenaScreen-module__no-pagination___VygwS {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.AthenaScreen-module__medical-table-new___Nv4t5.AthenaScreen-module__no-pagination___VygwS:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.AthenaScreen-module__medical-table-new___Nv4t5.AthenaScreen-module__no-pagination___VygwS::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.AthenaScreen-module__medical-table-new___Nv4t5.AthenaScreen-module__no-pagination___VygwS::-webkit-scrollbar-track {
  display: none;
}

.AthenaScreen-module__medical-table-empty___wU6Ko {
  padding: 14px 40px !important;
}

.AthenaScreen-module__icon-btn___JS58f {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.AthenaScreen-module__search-icon___fROLg {
  width: 24px;
  height: 24px;
  align-self: center;
}

.AthenaScreen-module__disable-select___EXiXj {
  user-select: none;
}

.AthenaScreen-module__break-word___AP835 {
  word-break: break-word;
}

.AthenaScreen-module__popup-clear-btn___mwjBx {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.AthenaScreen-module__scroll-m-b-20___lLrXx {
  scroll-margin-bottom: 20px;
}

.AthenaScreen-module__container___FDhHe {
  flex: 1;
  position: relative;
  overflow-y: auto;
  height: calc(100vh - var(--top-navigation) - 62px);
}
.AthenaScreen-module__container___FDhHe .AthenaScreen-module__headerContainer___YRbRU {
  flex-direction: row;
  justify-content: space-between;
  margin: 2em 20px;
}
.AthenaScreen-module__container___FDhHe .AthenaScreen-module__headerContainer___YRbRU .AthenaScreen-module__text___ikZnd {
  font-family: var(--font-family);
  font-weight: 400;
  color: #375844;
}
.AthenaScreen-module__container___FDhHe .AthenaScreen-module__buttonRow___uqHeK {
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 16px 0 0 16px;
}
.AthenaScreen-module__container___FDhHe .AthenaScreen-module__button___fx98v {
  height: 38px;
  width: auto;
  align-self: center;
}
.AthenaScreen-module__container___FDhHe .AthenaScreen-module__buttonDescription___yuIzK {
  font-size: 16px;
  font-weight: 500;
  line-height: 38px;
  color: #375844;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/screens/AthenaScreen/AthenaScreen.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,OAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AA8pBF;AA5pBE;EACE,mBAAA;EACA,8BAAA;EACA,gBAAA;AA8pBJ;AA5pBI;EEaF,+BApBO;EAqBP,gBAFmD;EFV/C,cAAA;AA+pBN;AA3pBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;AA6pBJ;AA1pBE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AA4pBJ;AAzpBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AA2pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  flex: 1;\n  position: relative;\n  overflow-y: auto;\n  height: calc(100vh - var(--top-navigation) - #{$settings-header});\n\n  .headerContainer {\n    flex-direction: row;\n    justify-content: space-between;\n    margin: 2em 20px;\n\n    .text {\n      @include get-font();\n      color: get-color(greenNew, dark);\n    }\n  }\n\n  .buttonRow {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin: 16px 0 0 16px;\n  }\n\n  .button {\n    height: 38px;\n    width: auto;\n    align-self: center;\n  }\n\n  .buttonDescription {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 38px;\n    color: get-color(greenNew, dark);\n  }\n}\n\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `AthenaScreen-module__font-s-10___vslrQ`,
	"fontS12": `AthenaScreen-module__font-s-12___m5nHw`,
	"fontS13": `AthenaScreen-module__font-s-13___pehF7`,
	"fontS14": `AthenaScreen-module__font-s-14___skGhI`,
	"fontS15": `AthenaScreen-module__font-s-15___CCLCl`,
	"fontS16": `AthenaScreen-module__font-s-16___MMiDQ`,
	"fontS18": `AthenaScreen-module__font-s-18___YRx94`,
	"fontS20": `AthenaScreen-module__font-s-20____pbEE`,
	"fontS22": `AthenaScreen-module__font-s-22___LIOan`,
	"fontS28": `AthenaScreen-module__font-s-28___A74wA`,
	"fontW400": `AthenaScreen-module__font-w-400___DFwDG`,
	"fontW500": `AthenaScreen-module__font-w-500___gnLwc`,
	"fontW600": `AthenaScreen-module__font-w-600___Ji1Dn`,
	"fontW700": `AthenaScreen-module__font-w-700___ZK614`,
	"p5": `AthenaScreen-module__p-5___bpMGE`,
	"p12": `AthenaScreen-module__p-12___YM8lP`,
	"p16": `AthenaScreen-module__p-16___xf12T`,
	"p30": `AthenaScreen-module__p-30___XNxu_`,
	"pB0": `AthenaScreen-module__p-b-0___pHzDl`,
	"pB5": `AthenaScreen-module__p-b-5___VwoRn`,
	"pB10": `AthenaScreen-module__p-b-10___ajKk7`,
	"pB12": `AthenaScreen-module__p-b-12___Ypm4E`,
	"pB16": `AthenaScreen-module__p-b-16___r498R`,
	"pB18": `AthenaScreen-module__p-b-18___GGz76`,
	"pB20": `AthenaScreen-module__p-b-20___OgMNd`,
	"pB25": `AthenaScreen-module__p-b-25___M_tI3`,
	"pB30": `AthenaScreen-module__p-b-30___EUGPs`,
	"pB50": `AthenaScreen-module__p-b-50___iKc1F`,
	"pT0": `AthenaScreen-module__p-t-0___lSab5`,
	"pT12": `AthenaScreen-module__p-t-12___L45TT`,
	"pT16": `AthenaScreen-module__p-t-16___dhXSs`,
	"pT18": `AthenaScreen-module__p-t-18___z8Q35`,
	"pT20": `AthenaScreen-module__p-t-20___kZHzt`,
	"pT30": `AthenaScreen-module__p-t-30___ntUIz`,
	"pT40": `AthenaScreen-module__p-t-40___pJiBI`,
	"pT50": `AthenaScreen-module__p-t-50___a0LTu`,
	"pL20": `AthenaScreen-module__p-l-20___JLUqD`,
	"pL30": `AthenaScreen-module__p-l-30___Qz7JA`,
	"pL40": `AthenaScreen-module__p-l-40___uXbae`,
	"pR16": `AthenaScreen-module__p-r-16___qgUgC`,
	"pR20": `AthenaScreen-module__p-r-20___Sxacm`,
	"pR30": `AthenaScreen-module__p-r-30___X4Anl`,
	"pR50": `AthenaScreen-module__p-r-50___dJNVl`,
	"pR60": `AthenaScreen-module__p-r-60___Aiuk0`,
	"mB1": `AthenaScreen-module__m-b-1___Z1Cei`,
	"mB2": `AthenaScreen-module__m-b-2___HblZ4`,
	"mB6": `AthenaScreen-module__m-b-6___VBwTg`,
	"mB8": `AthenaScreen-module__m-b-8___L2kWu`,
	"mB10": `AthenaScreen-module__m-b-10___kJqdZ`,
	"mB14": `AthenaScreen-module__m-b-14___XqHDM`,
	"mB16": `AthenaScreen-module__m-b-16___d4V7_`,
	"mB20": `AthenaScreen-module__m-b-20___k8M7v`,
	"mB22": `AthenaScreen-module__m-b-22___HzUcV`,
	"mB24": `AthenaScreen-module__m-b-24___llrVN`,
	"mB30": `AthenaScreen-module__m-b-30___fpiCi`,
	"mB32": `AthenaScreen-module__m-b-32___d1CCG`,
	"mB40": `AthenaScreen-module__m-b-40___e_vuo`,
	"mT2": `AthenaScreen-module__m-t-2___Hzly1`,
	"mT3": `AthenaScreen-module__m-t-3___swAKL`,
	"mT4": `AthenaScreen-module__m-t-4___wZEQg`,
	"mT5": `AthenaScreen-module__m-t-5___H178M`,
	"mT8": `AthenaScreen-module__m-t-8___n6QZB`,
	"mT10": `AthenaScreen-module__m-t-10___KCD3Z`,
	"mT15": `AthenaScreen-module__m-t-15___ONXQE`,
	"mT16": `AthenaScreen-module__m-t-16___GxBtq`,
	"mT20": `AthenaScreen-module__m-t-20___bG5gK`,
	"mT22": `AthenaScreen-module__m-t-22____6Tuq`,
	"mT30": `AthenaScreen-module__m-t-30___c9sB6`,
	"mT32": `AthenaScreen-module__m-t-32___yGYzq`,
	"mLAuto": `AthenaScreen-module__m-l-auto___rwP_H`,
	"mL4": `AthenaScreen-module__m-l-4____ZDeh`,
	"mL5": `AthenaScreen-module__m-l-5___sdkfL`,
	"mL6": `AthenaScreen-module__m-l-6___B0W5T`,
	"mL8": `AthenaScreen-module__m-l-8___YCq97`,
	"mL10": `AthenaScreen-module__m-l-10___jMVCR`,
	"mL16": `AthenaScreen-module__m-l-16___rIl2h`,
	"mL20": `AthenaScreen-module__m-l-20___LwYam`,
	"mL24": `AthenaScreen-module__m-l-24___AKOYG`,
	"mL30": `AthenaScreen-module__m-l-30___zVVRg`,
	"mL35": `AthenaScreen-module__m-l-35___NnKGW`,
	"mL40": `AthenaScreen-module__m-l-40___y68Ew`,
	"mR8": `AthenaScreen-module__m-r-8___fFgn5`,
	"mR10": `AthenaScreen-module__m-r-10___x7iSn`,
	"mR16": `AthenaScreen-module__m-r-16___sxL5f`,
	"mR20": `AthenaScreen-module__m-r-20___DvvPt`,
	"mR24": `AthenaScreen-module__m-r-24___xEVhp`,
	"mR30": `AthenaScreen-module__m-r-30___KIrAz`,
	"mR40": `AthenaScreen-module__m-r-40___VkkQt`,
	"borderR3": `AthenaScreen-module__border-r-3___dJE1O`,
	"borderR4": `AthenaScreen-module__border-r-4___mq59y`,
	"borderR6": `AthenaScreen-module__border-r-6___p0oQp`,
	"borderR10": `AthenaScreen-module__border-r-10___W4K8U`,
	"borderR12": `AthenaScreen-module__border-r-12___dPP_h`,
	"borderR16": `AthenaScreen-module__border-r-16___w_yRX`,
	"borderR50": `AthenaScreen-module__border-r-50___ezJTL`,
	"primaryBorder": `AthenaScreen-module__primary-border___q__ah`,
	"primaryBorderB": `AthenaScreen-module__primary-border-b___VIlkw`,
	"primaryBorderT": `AthenaScreen-module__primary-border-t___rrJyT`,
	"primaryBorderL": `AthenaScreen-module__primary-border-l___s11nc`,
	"primaryBorderR": `AthenaScreen-module__primary-border-r___a3fEF`,
	"secondaryBorder": `AthenaScreen-module__secondary-border____nNUn`,
	"secondaryBorderB": `AthenaScreen-module__secondary-border-b___QAfTG`,
	"secondaryBorderT": `AthenaScreen-module__secondary-border-t___XbOJA`,
	"secondaryBorderL": `AthenaScreen-module__secondary-border-l___hRpJp`,
	"secondaryBorderR": `AthenaScreen-module__secondary-border-r___S8lfo`,
	"gap0": `AthenaScreen-module__gap-0___a4GUK`,
	"gap2": `AthenaScreen-module__gap-2___saLHw`,
	"gap4": `AthenaScreen-module__gap-4___Rp4CW`,
	"gap5": `AthenaScreen-module__gap-5___jKXdD`,
	"gap6": `AthenaScreen-module__gap-6___VHULN`,
	"gap8": `AthenaScreen-module__gap-8____D8v5`,
	"gap10": `AthenaScreen-module__gap-10___SUk31`,
	"gap12": `AthenaScreen-module__gap-12___j82J3`,
	"gap14": `AthenaScreen-module__gap-14___NIwzH`,
	"gap16": `AthenaScreen-module__gap-16___J8P8K`,
	"gap18": `AthenaScreen-module__gap-18___G27c3`,
	"gap20": `AthenaScreen-module__gap-20___qc9vP`,
	"gap24": `AthenaScreen-module__gap-24___UfM5O`,
	"gap26": `AthenaScreen-module__gap-26___Jhg5U`,
	"gap30": `AthenaScreen-module__gap-30___OitN6`,
	"gap32": `AthenaScreen-module__gap-32___eX6TQ`,
	"gap40": `AthenaScreen-module__gap-40___Gb3u0`,
	"gap50": `AthenaScreen-module__gap-50___dnck1`,
	"flex1": `AthenaScreen-module__flex-1___hlkaX`,
	"flexNone": `AthenaScreen-module__flex-none___oFIkl`,
	"flexColumn": `AthenaScreen-module__flex-column___mn7mZ`,
	"flexRow": `AthenaScreen-module__flex-row___G7AU_`,
	"verticallyCentered": `AthenaScreen-module__vertically-centered___E1CYP`,
	"horizontallyCentered": `AthenaScreen-module__horizontally-centered___DVi3W`,
	"horizontallyEnd": `AthenaScreen-module__horizontally-end___CYw1V`,
	"verticallyStart": `AthenaScreen-module__vertically-start___pvy8Q`,
	"spaceBetween": `AthenaScreen-module__space-between___lVCa7`,
	"flexWrap": `AthenaScreen-module__flex-wrap___guX2W`,
	"height100": `AthenaScreen-module__height-100___btven`,
	"width50": `AthenaScreen-module__width-50___mMzzu`,
	"width100": `AthenaScreen-module__width-100___YnZWU`,
	"cursorPointer": `AthenaScreen-module__cursor-pointer___ZYbhN`,
	"cursorNotAllowed": `AthenaScreen-module__cursor-not-allowed___ITLlr`,
	"absoluteCentered": `AthenaScreen-module__absolute-centered___ZKOCB`,
	"absolute": `AthenaScreen-module__absolute___B0Hky`,
	"relative": `AthenaScreen-module__relative___zYls_`,
	"fixed": `AthenaScreen-module__fixed___b8oLf`,
	"visible": `AthenaScreen-module__visible___YM0JA`,
	"invisible": `AthenaScreen-module__invisible___X9AC0`,
	"col90": `AthenaScreen-module__col-90___HuTIm`,
	"colAuto": `AthenaScreen-module__col-auto___BgQUX`,
	"medicalTabs": `AthenaScreen-module__medical-tabs___mEAHq`,
	"medicalTableNew": `AthenaScreen-module__medical-table-new___Nv4t5`,
	"noPagination": `AthenaScreen-module__no-pagination___VygwS`,
	"medicalTableEmpty": `AthenaScreen-module__medical-table-empty___wU6Ko`,
	"iconBtn": `AthenaScreen-module__icon-btn___JS58f`,
	"searchIcon": `AthenaScreen-module__search-icon___fROLg`,
	"disableSelect": `AthenaScreen-module__disable-select___EXiXj`,
	"breakWord": `AthenaScreen-module__break-word___AP835`,
	"popupClearBtn": `AthenaScreen-module__popup-clear-btn___mwjBx`,
	"scrollMB20": `AthenaScreen-module__scroll-m-b-20___lLrXx`,
	"container": `AthenaScreen-module__container___FDhHe`,
	"headerContainer": `AthenaScreen-module__headerContainer___YRbRU`,
	"text": `AthenaScreen-module__text___ikZnd`,
	"buttonRow": `AthenaScreen-module__buttonRow___uqHeK`,
	"button": `AthenaScreen-module__button___fx98v`,
	"buttonDescription": `AthenaScreen-module__buttonDescription___yuIzK`
};
module.exports = ___CSS_LOADER_EXPORT___;
